export class ProgressBarUtil {
  public static workplaceProgressBarSections = (): string[] => {
    return ['CQC regulated', 'Find workplace', 'Confirm workplace', 'Employer type', 'Main service', 'Number of staff'];
  };

  public static userProgressBarSections = (): string[] => {
    return ['User details', 'Username and password', 'Security question', 'User research'];
  };

  public static workplaceFlowProgressBarSections = (): string[] => {
    return [
      WorkplaceFlowSections.SERVICES,
      WorkplaceFlowSections.VACANCIES_AND_TURNOVER,
      WorkplaceFlowSections.PAY_AND_BENEFITS,
      WorkplaceFlowSections.STAFF_DEVELOPMNENT,
      WorkplaceFlowSections.PERMISSIONS,
    ];
  };

  public static staffRecordProgressBarSections = (): string[] => {
    return ['Mandatory information', 'Personal details', 'Employment details', 'Training and qualifications'];
  };

  public static payAndPensionsMiniFlowBarSections = (value: number = 3): string[] => {
    const sections = [];
    if (value === 3 || value === 4) {
      for (let i = 0; i < value; i++) {
        sections.push(`Question ${i + 1}`);
      }
    }
    return sections;
  };
}

export enum WorkplaceFlowSections {
  SERVICES = 'Services',
  VACANCIES_AND_TURNOVER = 'Vacancies and turnover',
  PAY_AND_BENEFITS = 'Pay and benefits',
  STAFF_DEVELOPMNENT = 'Staff development',
  PERMISSIONS = 'Permissions',
}
